export const META_PIXEL_ID = '1633606685103530'

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Injects the Meta Pixel base code once and fires the initial PageView.
 * Mirrors the official snippet, adapted to run from the React bundle.
 */
export function initMetaPixel(pixelId: string = META_PIXEL_ID): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  const fbq: Window['fbq'] = function (...args: unknown[]) {
    if (fbq && fbq.callMethod) {
      fbq.callMethod.apply(fbq, args)
    } else if (fbq && fbq.queue) {
      fbq.queue.push(args)
    }
  } as NonNullable<Window['fbq']>

  window.fbq = fbq
  window._fbq = window._fbq || fbq
  fbq.push = fbq
  fbq.loaded = true
  fbq.version = '2.0'
  fbq.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  const noscript = document.createElement('noscript')
  const pixelImg = document.createElement('img')
  pixelImg.height = 1
  pixelImg.width = 1
  pixelImg.style.display = 'none'
  pixelImg.alt = ''
  pixelImg.src = `https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1`
  noscript.appendChild(pixelImg)
  document.body.appendChild(noscript)

  fbq('init', pixelId)
  fbq('track', 'PageView')
}

export function trackPixelEvent(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || !window.fbq) return
  window.fbq('track', event, params)
}
